
import {
  Component, Prop, PropSync, Mixins,
} from 'vue-property-decorator';
import { showSuccessAlertDialog } from '@/features/common/helpers';
import { VForm } from '@/features/common/types';
import PasswordInput from '@/features/common/components/PasswordInput.vue';
import { requiredRules } from '@/features/common/helpers/validationRules';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { changePassword } from '../../services/auth.services';
import { validatePasswordRequirements } from '../../helpers';

export interface FormData {
  pass: string,
  confirmPass: string,
}

@Component({
  components: {
    PasswordInput,
  },
})
export default class ChangePasswordForm extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) title!: string;

  @Prop({ default: false }) isNewUser!: boolean;

  @Prop({ default: false }) noAuth!: boolean;

  @PropSync('errorMessage', { default: '' }) syncedErrorMessage!: string;

  private data: FormData = {
    pass: '',
    confirmPass: '',
  }

  private isLoading = false;

  private showPass = false;

  private showConfirmPass = false;

  private passRules = [
    ...requiredRules,
  ]

  private confirmPassRules = [
    (v: string): string | boolean => {
      return v === this.data.pass || this.$t('setPassword.labels.shouldMatch') as string;
    },
  ]

  get passwordRequirements() {
    return validatePasswordRequirements(this.data.pass);
  }

  get isPasswordMeetRequirements() {
    return this.passwordRequirements.every((item) => item.met);
  }

  get exceptionType(): string | undefined {
    return this.$route.query.type as string;
  }

  get isHibpException(): boolean {
    return this.exceptionType === 'hibp';
  }

  private async submit() {
    this.syncedErrorMessage = '';

    const isValid = (this.$refs.form as VForm).validate();
    if (!isValid) return;

    if (this.noAuth) {
      this.$emit('submit', this.data);
      return;
    }

    this.isLoading = true;
    const res = await changePassword(
      this.data.pass,
      this.data.confirmPass,
      this.isNewUser,
    );
    this.isLoading = false;

    if (!res.successful) {
      this.syncedErrorMessage = res.errorMessage || '';
      return;
    }

    if (this.isNewUser) {
      const query = this.isHibpException ? '?greeting=true' : '';
      const url = `${process.env.VUE_APP_ORIGIN || '/'}${query}`;
      window.location.replace(url);
      return;
    }

    if (this.$route.name === 'change-password') {
      showSuccessAlertDialog(this.$t('setPassword.alert.successMessage') as string);
    }

    this.$router.push({ name: 'dashboard' });
  }
}
